import { memo } from "react";
import {
  Path as _Path,
  Rect as _Rect,
  Svg as _Svg
} from "react-native-svg";
import { themed } from "../../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return <_Svg
    viewBox="0 0 256 256"
    {...otherProps}
    height={size}
    width={size}
    fill={`${color}`}
  >
    <_Rect width="256" height="256" fill="none" />
    <_Path d="M152,120H136V56h8a32.1,32.1,0,0,1,32,32,8,8,0,0,0,16,0,48,48,0,0,0-48-48h-8V24a8,8,0,0,0-16,0V40H108a48,48,0,0,0,0,96h12v64H104a32.1,32.1,0,0,1-32-32,8,8,0,0,0-16,0,48,48,0,0,0,48,48h16v16a8,8,0,0,0,16,0V216h16a48,48,0,0,0,0-96Zm-32,0H108a32,32,0,0,1,0-64h12Zm32,80H136V136h16a32,32,0,0,1,0,64Z" />
  </_Svg>;
};
Icon.displayName = "CurrencyDollarFill";
const CurrencyDollarFill = memo(themed(Icon));
export {
  CurrencyDollarFill
};
//# sourceMappingURL=currency-dollar-fill.js.map
